/**
 * @packageDocumentation
 * @module HackerAPI.Email.Template
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import Trigger from "../trigger/trigger";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
/**
 * A container for building a mail template to be triggered by an action related to an event.
 * @class
 * @module HackerAPI.Email
 * @extends { HackerAPI.Base }
 */
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    /**
     * Creates a new mail template. Must be passed to an appropriate handler to actual update the backend
     * api.
     * @param mailTemplate
     */
    function Template(_a) {
        var _b = _a === void 0 ? {} : _a, name = _b.name, html = _b.html, subject = _b.subject, description = _b.description, slug = _b.slug, id = _b.id, _c = _b.trigger, trigger = _c === void 0 ? new Trigger() : _c;
        var _this = _super.call(this) || this;
        /**
         * The name of this mail template
         * @type { string }
         */
        _this.name = name;
        /**
         * The HTML body of the mail template
         * @type { string }
         */
        _this.html = html;
        /**
         * The subject of the email
         * @type { string }
         */
        _this.subject = subject;
        /**
         * The description of the mail template
         * @type { string }
         */
        _this.description = description;
        /**
         * @type { HackerAPI.Email.Trigger }
         */
        _this.trigger = new Trigger(trigger);
        /**
         * The slug of the mail template. If you set the slug then on the server it will be
         * eventslug + "_" + slug, if you don't then it will be eventslug + "_" + triggertype.
         * @type { string }
         */
        _this.slug = slug;
        /**
         * The ID of the mail template
         * @type { number }
         */
        _this.id = id;
        return _this;
    }
    /**
     * Gets all the mail templates for the given event from HackerAPI.
     * @param event - The event
     * @param token
     * @return { Promise<HackerAPI.Email.Template[]> } The templates
     */
    Template.fetchAll = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/mail-templates",
            method: "GET",
            token: token
        }).then(function (data) { return new Template(data); });
    };
    /**
     * Fetches a mail template from hackerapi
     * @param template
     * @param [token]
     * @returns
     */
    Template.fetch = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/mail/templates/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Template(data); });
    };
    /**
     * Adds a mail template for the event.
     * @param - The event
     * @param mailTemplate - Template to POST to server
     * @param token - Token to use with request
     * @returns The response from the server
     */
    Template.create = function (_a, mailTemplate, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/mail-templates",
            method: "POST",
            token: token,
            body: mailTemplate.toHackerAPIFormat()
        }).then(function (data) { return new Template(data); });
    };
    /**
     * Updates a mail template on hackerapi
     * @param template
     * @param [token]
     * @returns
     */
    Template.update = function (template, token) {
        return HackerAPIFetch({
            path: "/v2/mail/templates/" + template.id,
            method: "PUT",
            body: template.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Template(data); });
    };
    /**
     * Deletes a mail template on hackerapi
     * @param template
     * @param [token]
     * @returns
     */
    Template.delete = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/mail/templates" + id,
            method: "DELETE",
            token: token
        });
    };
    return Template;
}(Base));
export default Template;
//# sourceMappingURL=template.js.map